module.exports = __webpack_public_path__ + "static/media/IconStar.2d06702b.svg";